import React from 'react';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';

export const UserDropdown = ({ users, selectedUser, onChange }) => (
    <Select onChange={onChange} options={users} value={selectedUser} />
);

export const CentreDropdown = ({ centres, selectedCentres, onChange }) => (
    <MultiSelect 
    options={centres} 
    value={selectedCentres} 
    onChange={(selected) => onChange(selected)}
        labelledBy="Select"
    />
);

export const RateTemplateDropdown = ({ rateTemplates, selectedTemplates, onChange, id }) => (
    <MultiSelect 
        id={`SalesSelect${id}`} 
        name={`SalesSelect${id}`}
        options={rateTemplates}
        value={selectedTemplates}
        onChange={onChange}
        labelledBy="Select"
    />
);

